import { SerializedSocialPost, SerializedSocialPostDay } from '../promote/types';

/**
 * The numbers that the daily line can show. Reach has no line (design social-connectors c1). Only X
 * gives `linkClicks` (design x-connector e1); on the other platforms it is null, so it is not in
 * the switch.
 */
export const socialPostChartMetrics = ['views', 'likes', 'comments', 'shares', 'saves', 'linkClicks'] as const;
export type SocialPostChartMetric = (typeof socialPostChartMetrics)[number];

export interface DailyDifferencePoint {
  /** `YYYY-MM-DD`, UTC. */
  date: string;
  /** The growth of the number on this day. Null when one of the two totals is not known. */
  value: number | null;
}

/**
 * The daily rows of a post hold running totals. This gives the difference between each day and
 * the day before it. The first day has no day before it, so it has no point. A total that went
 * down (the platform corrected its count) gives 0, not a negative growth.
 */
export function dailyDifference(
  days: SerializedSocialPostDay[],
  metric: SocialPostChartMetric
): DailyDifferencePoint[] {
  return days.slice(1).map((day, index) => {
    const before = days[index]?.[metric] ?? null;
    const now = day[metric];
    return { date: day.date, value: before === null || now === null ? null : Math.max(0, now - before) };
  });
}

/** The numbers of the switch: a number that the platform does not give for this post is left out. */
export function availableChartMetrics(
  post: Pick<SerializedSocialPost, SocialPostChartMetric>
): SocialPostChartMetric[] {
  return socialPostChartMetrics.filter((metric) => post[metric] !== null);
}
